<template>
    <v-app class="verofresh">
      <router-view></router-view>
      <maintenance-modal></maintenance-modal>
    </v-app>
</template>

<script>
import MaintenanceModal from '@/components/shared/MaintenanceModal'
import { setLocaleAsync } from '@/i18n'

export default {
  name: 'EmptyLayout',
  components: {
    MaintenanceModal
  },
  mounted () {
    // No user context here, so we need to guess the locale.
    // Try loading the locale from the store
    let locale = this.$store.getters['localeModule/locale']
    // Default to English
    if (locale == null) locale = 'en'
    setLocaleAsync(locale)
  }
}
</script>

<style scoped>
  .empty-container {
    display: flex;
    height: 100vh;
    flex-direction: column;
  }
</style>
